module.exports = __webpack_public_path__ + "img/12.afe3fbe6.jpg";